import { Controller } from "@hotwired/stimulus"

// Submits its form a beat after the last keystroke, so a search field filters
// as it is typed rather than once per Enter — and without a request per
// character.
//
// The form targets a Turbo frame, so the response replaces the results and
// leaves this field, and the caret in it, untouched. That is the whole reason
// the field sits outside the frame it drives.
export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  disconnect() { this.cancel() }

  submit() {
    this.cancel()
    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  // Enter submits the form natively; without this the pending timer would fire
  // a second, identical request a moment later.
  cancel() { clearTimeout(this.timer) }
}
